// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamento_BuscaFormasPagtoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/formas_pagamento/buscaFormasPagto
 *
 * Returns the payment methods projected into a flat id-keyed map of
 * `{ <forma_pagamento_id>: <forma_pagamento_nome> }`, built in the controller
 * from Formas_pagamento_model::kvFormasPagto(). Used by legacy form selectors
 * that expect a flat option map. Dynamic numeric keys mean a Row class would
 * mis-shape this into a list, so we keep it as a typed map.
 *
 * @see Formas_pagamento_model::kvFormasPagto()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type FormasPagamento_BuscaFormasPagtoResponseDados = Record<number, string>;

export type FormasPagamento_BuscaFormasPagtoResponse = ApiResponse<FormasPagamento_BuscaFormasPagtoResponseDados>;

registerResponseContract('FormasPagamento_BuscaFormasPagtoResponse', {})
